import { Clima } from '../../service/clima';
import RainChart from '../WeatherChart/rain';
import { Temperature } from '../WeatherChart/temperature';
import { WindSpeed } from '../WeatherChart/wind-speed';
import { WeatherSummary } from './summary';
import './WeatherForecast.css';

interface Props {
  persistedWeatherData: Clima;
  globalScales: GlobalScales;
}

export function ChartMobile({ persistedWeatherData, globalScales }: Props) {
  return (
    <div className="d-lg-none">
      {/* HOJE */}
      <section className="section_chart">
        <h5 className="text-center mb-3 subtitle">Previsão para hoje</h5>
        <WeatherSummary
          weather={persistedWeatherData.hoje}
          units={persistedWeatherData.unidades}
        />

        <h6 className="text-center title_chart">
          Temperatura ({persistedWeatherData.unidades.temperatura})
        </h6>
        <Temperature
          weather={persistedWeatherData.hoje}
          syncId="hoje_temp"
          globalMaxTemp={globalScales.temp}
        />

        <h6 className="text-center title_chart">
          Chuva ({persistedWeatherData.unidades.precipitacao})
        </h6>
        <RainChart
          weather={persistedWeatherData.hoje}
          globalMaxRain={globalScales.rain}
        />

        <h6 className="text-center title_chart">
          Velocidade do Vento ({persistedWeatherData.unidades.vento})
        </h6>
        <WindSpeed
          weather={persistedWeatherData.hoje}
          syncId="hoje_wind"
          globalMaxWind={globalScales.wind}
        />
      </section>

      {/* AMANHÃ */}
      <section className="section_chart">
        <h5 className="text-center mb-3 subtitle">Previsão para amanhã</h5>
        <WeatherSummary
          weather={persistedWeatherData.amanha}
          units={persistedWeatherData.unidades}
        />

        <h6 className="text-center title_chart">
          Temperatura ({persistedWeatherData.unidades.temperatura})
        </h6>
        <Temperature
          weather={persistedWeatherData.amanha}
          syncId="amanha_temp"
          tomorrow
          globalMaxTemp={globalScales.temp}
        />

        <h6 className="text-center title_chart">
          Chuva ({persistedWeatherData.unidades.precipitacao})
        </h6>
        <RainChart
          weather={persistedWeatherData.amanha}
          globalMaxRain={globalScales.rain}
        />

        <h6 className="text-center title_chart">
          Velocidade do Vento ({persistedWeatherData.unidades.vento})
        </h6>
        <WindSpeed
          weather={persistedWeatherData.amanha}
          syncId="amanha_wind"
          tomorrow
          globalMaxWind={globalScales.wind}
        />
      </section>
    </div>
  );
}
